import React, { useState, useRef, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Checkbox } from 'primereact/checkbox';
import { Tooltip } from 'primereact/tooltip';

import api from '../../service/api';
import CreateSupplier from '../Supplier/create';
import CreateExpenseCategory from '../ExpenseCategory/create';
import InputDecimal from '../../components/InputDecimal';

export default function CreateExpense(props){
    let {
        visible,
        handleCancel,
        onCreate,
        travel,
        ispaid,
        truck
    } = props;

    let emptyExpense = {
        description: '',
        truck: null,
        due_date: '',
        purchase_date: (new Date()).getTime(),
        parcelable: false,
        amount: null,
        ispaid: ispaid || false,
        withouttravel: false,
        installment: null,
        supplier: null,
        category: null
    };

    const [expense, setExpense] = useState(emptyExpense);
    const [trucks, setTrucks] = useState([]);
    const [dueDateOpctional, setDueDateOptional] = useState(true);
    const [suppliers, setSuppliers] = useState([]);
    const [categories, setCategories] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [showCreateSupplier, setShowCreateSupplier] = useState(false);
    const [showCreateCategory, setShowCreateCategory] = useState(false);

    const toast = useRef(null);
    const checkbox = useRef(null);

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || (e.value) || '';
        let _expense = { ...expense };
        _expense[`${name}`] = val;

        setExpense(_expense);
    }

    const listTrucks = () => {
        api().get('truck/list').then(response => {
            if(response.status === 200 && response.data.result){
                setTrucks(response.data.data);
            }
        });
    }

    const listSuppliers = (defaultValue = null) => {
        api().get('supplier/list').then(response => {
            if(response.status === 200 && response.data.result){
                setSuppliers(response.data.data);
                if(defaultValue) onInputChange({ value: defaultValue }, 'supplier');
            }
        });
    }

    const listCategories = (defaultValue = null) => {
        api().get('expensecategory/list').then(response => {
            if(response.status === 200 && response.data.result){
                setCategories(response.data.data);
                if(defaultValue) onInputChange({ value: defaultValue }, 'category');
            }
        });
    }

    const onHide = () => {
        setExpense({...emptyExpense});
        handleCancel();
    }

    useEffect(() => {
        listTrucks();
        listSuppliers();
        listCategories();
    }, []);

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={visible} style={{ width: '450px' }} header="Nova Despesa" modal className="p-fluid" footer={() => {
                return(
                    <>
                        <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={onHide} />
                        <Button label="Salvar" onClick={() => {
                            if(!expense.amount
                                || !expense.description || !expense.purchase_date)
                                    return setSubmitted(true);
                            
                            setSubmitted(false);
                            setDisabled(true);
                            var _expense = {...expense};
                    
                            _expense['purchase_date'] = (new Date(_expense['purchase_date'])).getTime();
                            if(_expense['due_date']) _expense['due_date'] = (new Date(_expense['due_date'])).getTime();

                            if(travel) _expense['travel'] = travel;
                            if(truck) _expense['truck'] = truck;
                            if(_expense['ispaid']) _expense['payment_date'] = _expense['purchase_date'];
                    
                            api().post('/expense/create', _expense).then(response => {
                                setExpense({...emptyExpense});
                                setDisabled(false);
                                if(response.status === 200 && response.data.result){
                                    toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                                    if(typeof onCreate === 'function')
                                        onCreate();
                                } else {
                                    toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                                    setDisabled(false);
                                }
                            });

                        }} loading={disabled} icon="pi pi-check" className="p-button-text"  />
                    </>
                );
            }} onHide={onHide}>
                <CreateSupplier visible={showCreateSupplier} handleCancel={() => {
                    setShowCreateSupplier(false);
                }} onCreate={response => {
                    setShowCreateSupplier(false);
                    if(response.data)
                        listSuppliers(response.data);
                }} />
                <CreateExpenseCategory visible={showCreateCategory} handleCancel={() => {
                    setShowCreateCategory(false);
                }} onCreate={response => {
                    setShowCreateCategory(false);
                    if(response.data)
                        listCategories(response.data);
                }} />
                
                <div className='formgrid grid'>
                    <div className="field col">
                        <label htmlFor="description">Descrição</label>
                        <InputText disabled={disabled} id="description" required autoFocus  value={expense.description}  onChange={(e) => onInputChange(e, 'description')} />
                        {submitted && !expense.description && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                    </div>
                </div>
                <div className='formgrid grid'>
                    <div className="field col">
                        <label htmlFor='supplier'>Fornecedor (Opcional)</label>
                        <div style={{ display: 'flex' }}>
                            <Dropdown disabled={disabled} filter value={expense.supplier} style={{ width: '100%' }} showClear emptyMessage='Nenhum registro encontrado'  id="supplier" options={suppliers} onChange={(e) => onInputChange(e, 'supplier')} optionLabel="name" optionValue='code' placeholder="Selecione o fornecedor" />
                            <Button disabled={disabled} onClick={() => {
                                setShowCreateSupplier(true);
                            }} className='p-button-text' icon='pi pi-plus' />
                        </div>
                        
                    </div>
                </div>
                <div className='formgrid grid'>
                    <div className="field col">
                        <label htmlFor='supplier'>Categoria (Opcional)</label>
                        <div style={{ display: 'flex' }}>
                            <Dropdown disabled={disabled} filter value={expense.category} style={{ width: '100%' }} showClear emptyMessage='Nenhum registro encontrado'  id="category" options={categories} onChange={(e) => onInputChange(e, 'category')} optionLabel="description" optionValue='code' placeholder="Selecione uma categoria" />
                            <Button disabled={disabled} onClick={() => {
                                setShowCreateCategory(true);
                            }} className='p-button-text' icon='pi pi-plus' />
                        </div>
                        
                    </div>
                </div>
                {!travel ? (
                    <div className="field-checkbox">
                        <hr />
                        <Checkbox disabled={disabled} inputId="binary" checked={expense.parcelable} onChange={e => {
                            var  _expense = { ...expense};
                            _expense['parcelable'] = e.checked;
                            setExpense(_expense);
                            setDueDateOptional(!e.checked);
                            
                        }} />
                        <label htmlFor="binary">Despesa Parcelada</label>
                    </div>
                ) : ''}
                
                {expense.parcelable ? (
                    <div className='formgrid grid'>
                        <div className="field col">
                            <label htmlFor='parcelable'>QTD. Parcelas</label>
                            <InputNumber autoFocus ref={checkbox} disabled={disabled} id="parcelable" value={expense.installment} maxFractionDigits={0} mode='decimal' onChange={(e) => onInputChange(e, 'installment')} />
                            {submitted && !expense.parcelable && <small className="p-invalid p-error">Preencha este campo com uma valor interior e maior que zero para continuar.</small>}
                        </div>
                    </div>
                ) : ''}
                <div className='formgrid grid'>
                    <div className="field col">
                        <label htmlFor="due_date">{!dueDateOpctional ? 'Primeiro Vencimento' : 'Vencimento (Opcional)'} </label>
                        <Calendar disabled={disabled} id="due_date" dateFormat="dd/mm/yy" locale='pt-br' value={new Date(expense.due_date)} onChange={(e) => onInputChange(e, 'due_date')} showIcon />
                        {submitted && expense.parcelable && !expense.due_date && <small className="p-invalid p-error">Como existe parcelas, é necessário informar a data inicial de vencimento.</small>}

                    </div>
                    <div className="field col">
                        <label htmlFor="purchase_date">Data da Compra </label>
                        <Calendar disabled={disabled} id="purchase_date" dateFormat="dd/mm/yy" locale='pt-br' value={new Date(expense.purchase_date)} onChange={(e) => onInputChange(e, 'purchase_date')} showIcon />
                        {submitted && !expense.purchase_date && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                    </div>
                </div>
                { !expense.parcelable ? (
                    <div className="field-checkbox">
                        <hr />
                        <Checkbox disabled={disabled} inputId="binary" checked={expense.ispaid} onChange={e => {
                            var  _expense = { ...expense};
                            _expense['ispaid'] = e.checked;
                            setExpense(_expense);
                        }} />
                        <label htmlFor="binary">Despesa Paga</label>
                    </div>
                ) : ''}
                
                <div className="formgrid grid">
                    <div className="field col">
                        <label htmlFor="amount">Valor</label>
                        <InputDecimal mode="currency" label="Valor Total" disabled={disabled} id="amount" value={expense.amount || ''} onChange={(e) => onInputChange(e, 'amount')} />
                        {submitted && !expense.amount && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                    </div>
                </div>

                { travel ? (
                    <div className="field-checkbox">
                        <hr />
                        <Checkbox disabled={disabled} inputId="withOutTravel" checked={expense.withouttravel} onChange={e => {
                            var  _expense = { ...expense};
                            _expense['withouttravel'] = e.checked;
                            setExpense(_expense);
                        }} />
                        <label htmlFor="withOutTravel">Despesa Desvinculada da Viagem 
                        <i style={{ color: '#c33440', marginLeft: 5 }} 
                        data-pr-tooltip="Marcando esta opção, a despesa gerada
                            não será somada ao montante de despesas dessa viagem!"
                            data-pr-position="top"
                            className="pi pi-info-circle text-danger"></i>
                        </label>
                        <Tooltip target={'.pi-info-circle'} />
                    </div>
                ) : ''}

                {!travel ? (
                    <div className='formgrid grid'>
                        <div className="field col">
                            <label htmlFor='truck'>Caminhão (Opcional)</label>
                            <Dropdown disabled={disabled} value={expense.truck} showClear  id="truck" options={trucks} onChange={(e) => onInputChange(e, 'truck')} optionLabel="plate" optionValue='code' placeholder="Selecione o caminhão" />
                        </div>
                    </div>
                ) : ''}
            </Dialog>
        </>
        
    );
}